(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/definitions/trajectory-widget-definition.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/definitions/trajectory-widget-definition.js');
"use strict";


const KambiWidgetDefinition = svs.oddset_kambi.components.kambiWidgetUtils.definitions.KambiWidgetDefinition;
const buildFilter = svs.oddset_kambi.components.kambiWidgetUtils.buildFilter;
const {
  WIDGET_ID,
  WIDGET_TAG
} = svs.oddset_kambi.components.kambiWidgetUtils.constants;
const TROTTING_FILTER = {
  trav: {
    sverige: ['arvika', 'axevalla', 'bergsaker', 'boden', 'bollnas', 'dannero', 'eskilstuna', 'farjestad', 'gavle', 'hagmyren', 'halmstad', 'hoting', 'jagersro', 'kalmar', 'karlshamn', 'lindesberg', 'lycksele', 'mantorp', 'oviken', 'romme', 'rattvik', 'skelleftea', 'solvalla', 'solanget', 'tingsryd', 'umea', 'vaggeryd', 'visby', 'aby', 'amal', 'arjang', 'orebro', 'ostersund']
  }
};
class TrajectoryWidgetDefinition extends KambiWidgetDefinition {
  constructor() {
    super(WIDGET_ID.trajectoryWidget, WIDGET_TAG.trajectoryWidget, {
      eventColumn2Placeholder2: [{
        widgetId: WIDGET_ID.trajectoryWidget,
        order: 1,
        filter: buildFilter(TROTTING_FILTER)
      }]
    });
  }
}
setGlobal('svs.oddset_kambi.components.kambiWidgetUtils.definitions.TrajectoryWidgetDefinition', TrajectoryWidgetDefinition);

 })(window);